export default function (defaultDataValue = null) {
  return {
    data() {
      return {
        isLoading: true,
        data: defaultDataValue,
      };
    },
    async created() {
      this.data = await this.fetchData();
      this.isLoading = false;
    },
    methods: {
      async reloadData() {
        // 暴露可复用的方法
        this.data = await this.fetchData();
      },
    },
  };
}
